import { render, staticRenderFns } from "./mobileHeader.vue?vue&type=template&id=a888b026&scoped=true&"
import script from "./mobileHeader.vue?vue&type=script&lang=js&"
export * from "./mobileHeader.vue?vue&type=script&lang=js&"
import style0 from "./mobileHeader.vue?vue&type=style&index=0&id=a888b026&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a888b026",
  null
  
)

export default component.exports